var ENV = 'production';
var VERSION = null;
var SESSION = null;
var hosts = {
  beta: 'https://beta.api.huggg.me',
  dev: 'https://dev.api.huggg.me',
  local: 'http://local.api.huggg.me',
  production: 'https://api.huggg.me',
  stage: 'https://stage.api.huggg.me'
};
var setEnv = function setEnv(env) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (Object.keys(hosts).includes(env)) {
    ENV = env;
    VERSION = version;
  } else {
    throw new Error('unknown environment specified.');
  }
};
var setSession = function setSession(session) {
  SESSION = session;
};

/**
 * You should defer calling these methods until you are about to use the URL,
 * as they are client-env dependent. Early calling (e.g in constructors) may
 * result in your app caching a URL to the default environment before the
 * client app is fully bootstrapped.
 */
var urls = {
  api: function api() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return "".concat(hosts[ENV]).concat(path);
  },
  apiV2: function apiV2() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return "".concat(hosts[ENV], "/api/v2").concat(path);
  },
  apiV3: function apiV3() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return "".concat(hosts[ENV], "/v3").concat(path);
  }
};
var context = function context() {
  return {
    clientVersion: VERSION,
    session: SESSION
  };
};
var api = {
  timeout: 120000,
  /**
   * These consts mean we'll retry over a period of 254 seconds (~ 5 minutes)
   * at intervals of 2, 4, 8, 16, 32, 64 and then 128 seconds
   */
  backoffDelay: 2000,
  // 2 seconds
  delayMultiplier: 2,
  retryLimit: 7
};
export { urls, setEnv, setSession, context, api, hosts };